"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, props, {
    viewBox: '0 0 16 16',
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1432.000000, -397.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(490.000000, 375.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(930.000000, 10.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,12.5 C7.94133333,12.5 7.88333333,12.4893333 7.82666667,12.4686667 C7.82133333,12.4666667 7.81666667,12.4653333 7.812,12.4633333 C7.748,12.4373333 7.69266667,12.4006667 7.646,12.3533333 L5.14666667,9.85333333 C4.952,9.65866667 4.952,9.34133333 5.14666667,9.146 C5.24133333,9.05133333 5.36666667,8.99933333 5.5,8.99933333 C5.63333333,8.99933333 5.75933333,9.05133333 5.85333333,9.146 L7.5,10.7926667 L7.5,4.5 C7.5,4.224 7.724,4 8,4 C8.276,4 8.5,4.224 8.5,4.5 L8.5,10.7926667 L10.1466667,9.146 C10.2413333,9.05133333 10.3666667,8.99933333 10.5,8.99933333 C10.6333333,8.99933333 10.7593333,9.05133333 10.8533333,9.146 C11.048,9.34066667 11.048,9.658 10.8533333,9.85333333 L8.35333333,12.3533333 C8.30666667,12.4 8.25133333,12.4366667 8.18933333,12.4626667 C8.184,12.4646667 8.178,12.4673333 8.172,12.4693333 C8.11533333,12.49 8.058,12.5 8,12.5 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,16 C3.58866667,16 0,12.4113333 0,8 C0,3.58866667 3.58866667,0 8,0 C12.4113333,0 16,3.58866667 16,8 C16,12.4113333 12.4113333,16 8,16 Z M8,1 C4.14,1 1,4.14 1,8 C1,11.86 4.14,15 8,15 C11.86,15 15,11.86 15,8 C15,4.14 11.86,1 8,1 Z",
    id: "Shape"
  })))))));
});